import { useInfiniteQuery } from '@tanstack/react-query'
import { PulsePaginatedFilters } from 'api/pulse'
import { getFillRateByCompanyKey } from './keys'
import {
  FillRateByCompany,
  getFillRateByCompany,
} from 'api/pulse/fillRateByCompany'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useFillRateByCompany(query: PulsePaginatedFilters) {
  return useInfiniteQuery<FillRateByCompany>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getFillRateByCompanyKey(query),
    queryFn: async ({ pageParam = 0, signal }) => {
      const start = (pageParam as number) * query.pageSize
      const fetchedData = await getFillRateByCompany(
        {
          ...query,
          page: start,
        },
        signal
      )
      return fetchedData
    },
    enabled: !!query.companyIds?.length,
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) =>
      !lastPage.length || lastPage.length < query.pageSize
        ? undefined
        : allPages.length,
  })
}
